import { Link } from "react-router-dom";
import { useState } from "react";
import { api } from "@/lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setState("submitting");
    try {
      await api.post("/newsletter/subscribe", { email, source: "footer" });
      setState("done");
      setEmail("");
    } catch {
      setState("idle");
    }
  };

  return (
    <footer className="relative mt-32 border-t border-white/10 bg-black overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <div className="font-display text-3xl text-neon-pink">Booty Breeze</div>
          <p className="text-white/50 text-sm mt-3 max-w-sm leading-relaxed">
            Adult-themed air fresheners for the drivers who like their rides a little
            sultrier. Made in small batches. Shipped discreetly.
          </p>
          <form onSubmit={submit} className="mt-6 flex gap-2 max-w-sm" data-testid="footer-newsletter-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Join the list · get 10% off"
              data-testid="footer-newsletter-email"
              className="flex-1 bg-white/5 border border-white/10 rounded-full px-4 py-2.5 text-xs text-white placeholder:text-white/40 focus:outline-none focus:border-[#FF3D8B]"
            />
            <button
              type="submit"
              data-testid="footer-newsletter-submit"
              disabled={state === "submitting" || state === "done"}
              className="px-4 py-2.5 rounded-full bg-[#FF3D8B] text-black font-bold uppercase tracking-widest text-[11px] hover:bg-[#ff5ba0] transition-colors disabled:opacity-40"
            >
              {state === "done" ? "Thanks" : "Join"}
            </button>
          </form>
        </div>
        <div>
          <div className="text-white/40 text-xs uppercase tracking-widest mb-4">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="text-white/70 hover:text-[#FF3D8B] transition-colors">All Scents</Link></li>
            <li><Link to="/shop" className="text-white/70 hover:text-[#FF3D8B] transition-colors">Bestsellers</Link></li>
            <li><Link to="/gift-match" className="text-white/70 hover:text-[#FF3D8B] transition-colors" data-testid="footer-gift-match-link">Gift Match Quiz</Link></li>
            <li><Link to="/unwrap" className="text-white/70 hover:text-[#FF3D8B] transition-colors" data-testid="footer-unwrap-link">Unwrap for 10% off</Link></li>
            <li><Link to="/song" className="text-white/70 hover:text-[#FF3D8B] transition-colors" data-testid="footer-song-link">The Song (TikTok)</Link></li>
            <li><Link to="/blog" className="text-white/70 hover:text-[#FF3D8B] transition-colors">BreezeBlog</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-white/40 text-xs uppercase tracking-widest mb-4">Help</div>
          <ul className="space-y-2 text-sm">
            <li><span className="text-white/70">admin@bootybreeze.com</span></li>
            <li><span className="text-white/70">Shipping & Returns</span></li>
            <li><Link to="/login" className="text-white/40 hover:text-[#A855F7] transition-colors">Sign in / Register</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-white/40 text-xs">
        © {new Date().getFullYear()} Booty Breeze. All rights reserved.
      </div>
      {/* Massive watermark */}
      <div
        aria-hidden
        className="pointer-events-none select-none absolute -bottom-10 left-0 right-0 text-center font-display text-[18vw] leading-none text-white/[0.03] whitespace-nowrap"
      >
        BOOTY BREEZE
      </div>
    </footer>
  );
}
